import { Box, Button, Heading, Text, useToast } from "@chakra-ui/react"
import axios from "axios"
import RegisterForm from "components/Organismos/RegisterForm"
import LoginTemplate from "components/Templates/Login"
import { Cpf } from "models/domain/cpf.domain"
import { Email } from "models/domain/email.domain"
import { PhoneNumber } from "models/domain/phoneNumber.domain"
import { RegisterUserFormData } from "models/register-user.model"
import { useCallback } from "react"
import { Link, useNavigate } from "react-router-dom"
import { registerUserRequest } from "store/modules/users/actions/registerUser"
import { useDispatchToPromise } from "utils/dispatch-to-promise"

const RegisterPage = () => {
    const navigate = useNavigate();
    const toast = useToast();
    const dispatchAsPromise = useDispatchToPromise();

    const handleLogin = async (data: RegisterUserFormData) => {
        await dispatchAsPromise(registerUserRequest, {
            user: {
                nome: data.fullname,
                cpf: Cpf.fromString(data.cpf).getWithoutMask(),
                telefone: PhoneNumber.fromString(data.phoneNumber).getWithoutMask(),
                email: Email.fromString(data.email).toString(),
                dataNascimento: data.birthDate,
                password: data.password,
                confirmPassword: data.confirmPassword,
                endereco: {
                    bairro: data.neighborhood,
                    logradouro: data.streetName,
                    tipoLogradouro: data.streetType,
                    numero: data.addressNumber,
                    complemento: data.addressComplement,
                    cep: data.cep,
                    municipio: data.city,
                    uf: data.state
                }
            },
        });
        toast({
            status: 'success',
            description: 'Conta cadastrada com sucesso! Agora você pode entrar com suas credenciais.'
        });
        navigateToLogin();
    }

    const handleFailed = (err: unknown) => {
        if (axios.isAxiosError(err)) {
            if (err.response?.data.usuario && Array.isArray(err.response.data.usuario)) {
                toast({
                    status: 'warning',
                    description: err.response.data.usuario.join('\n')
                });
            } else {
                toast({
                    status: 'warning',
                    description: 'Erro ao entrar no sistema.'
                });
            }
        }
    }

    const navigateToLogin = useCallback(() => navigate('/login'), []);

    return (
        <LoginTemplate
            header={(
                <Box px={2}>
                    <Heading>Crie sua conta</Heading>
                    <Text>Para poder utilizar nosso mapa, você precisa criar sua conta.</Text>
                </Box>
            )}
            form={(
                <RegisterForm
                    onSuccess={handleLogin}
                    onFailed={handleFailed}
                />
            )}
            bottomInformation={(
                <Link to="/login"><Button variant="link">Já possui uma conta? Entre agora.</Button></Link>
            )}
        />
    )
}
export default RegisterPage